module.exports = __webpack_public_path__ + "img/m.0072e297.jpg";